import React from "react";
import { DrawerLabel, DrawerSection } from "../styles";
import ContextDeeplink from "./ContextDeeplink";
import type { StationsTextEntry, TextRegistryScope } from "../types";

interface Props {
	entry: StationsTextEntry;
	scope: TextRegistryScope;
}

export default function DrawerContextTab({ entry, scope }: Props) {
	return (
		<div>
			<DrawerSection>
				<DrawerLabel>Key</DrawerLabel>
				<code style={{ fontSize: "0.8125rem", color: "#475569", wordBreak: "break-all" }}>{entry.key}</code>
			</DrawerSection>
			<DrawerSection>
				<DrawerLabel>Screen</DrawerLabel>
				<span style={{ fontSize: "0.875rem" }}>{entry.screen}</span>
			</DrawerSection>
			<DrawerSection>
				<DrawerLabel>Group</DrawerLabel>
				<span style={{ fontSize: "0.875rem" }}>{entry.group}</span>
			</DrawerSection>
			<DrawerSection>
				<DrawerLabel>Preview link</DrawerLabel>
				<ContextDeeplink
					scope={scope}
					entryKey={entry.key}
					screen={entry.screen}
				/>
			</DrawerSection>
		</div>
	);
}
